import axios from 'axios';
import { API_KEY } from '../config/appConfig';
import { Toaster } from '../shared/components/common/toaster';
import { Logout } from './authService';

const axiosNew = axios.create({
	baseURL: `${API_KEY}/api/`,
	headers: {
		'Content-Type': 'application/json',
	},
	// Only 2xx responses are treated as success; all others
	// are passed to the response interceptor for per-call handling.
	validateStatus: function (status) {
		return status >= 200 && status < 300;
	},
});

axiosNew.interceptors.request.use(function (config) {
	config.params = { ...config.params, ...{ culture: 'en-US' } };
	const token = localStorage.getItem('token');
	config.headers.Authorization = token ? `Bearer ${token}` : '';
	return config;
});

axiosNew.interceptors.response.use(
	(res) => {
		if (
			res.status >= 200 &&
			res.status < 300 &&
			res.config.method !== 'get' &&
			!res.config?.headers?.hide_success_toaster
		) {
			Toaster({ msg: 'Request Successfully Completed', isError: false });
		}
		return res;
	},
	async (error) => {
		let status = error?.response?.status;

		// For 401/403 we let individual calls handle the error,
		// but we no longer cancel other in-flight requests.
		if (status === 401) {
			Toaster({ msg: 'Session expired, Please login!' });
			Logout();
			window.location.href = '/login';
			return;
		}
		if (status === 403) {
			Toaster({ msg: 'Access denied' });
			return;
		}

		if (
			!error?.config?.headers?.hide_toaster &&
			!error?.response?.data?.UserLockedOut
		) {
			if (axios.isCancel(error)) {
				let cancelCount = parseInt(localStorage.getItem('cancelCount')) || 0;
				cancelCount += 1;
				localStorage.setItem('cancelCount', cancelCount);
				if (cancelCount >= 5) {
					localStorage.setItem("isCancelAPI", "0");
				}
				let alreadyCancelled = localStorage.getItem('isCancelAPI');
				if (cancelCount >= 5 && alreadyCancelled !== "1") {
					localStorage.setItem('isCancelAPI', "1");
					// customAlert(
					// 	'Your session has expired. Please log out and log back in.',
					// 	function () {
					// 		Logout();
					// 		window.location.href = '/login';
					// 		return;
					// 	}
					// );
					return;
				}
				return;
			}
			Toaster({
				msg:
					formatError(error?.response?.data) ||
					'Something went wrong. Please try again',
			});
		}
		return Promise.reject(error);
	}
);

export const axiosGet = (params, url, id, responseType = '', headers) => {
	let fullUrl = id ? `${url}/${id}` : url;
	return axiosNew.get(fullUrl, {
		params: params,
		headers: headers,
		responseType: responseType,
	});
};

export const axiosPost = (body, url, headers, responseType) => {
	return axiosNew.post(url, body, {
		headers: headers,
		responseType: responseType,
	});
};

export const axiosPut = (body, url, headers, responseType) => {
	return axiosNew.put(url, body, {
		headers: headers,
		responseType: responseType,
	});
};

export const axiosPatch = (url, body, headers, responseType) => {
	return axiosNew.patch(url, body, {
		headers: headers,
		responseType: responseType,
	});
};

export const axiosDelete = (url, headers, responseType) => {
	return axiosNew.delete(url, {
		headers: headers,
		responseType: responseType,
	});
};

export { axiosNew };

const formatErrorObject = (error) => {
	const keys = Object.keys(error);
	const errors = keys.map((k) => error[k]);
	if (errors.join('<br />') !== "[object Object]") {
		return errors.join('<br />');
	}
	if (errors.length && error[0]?.message) {
		return error[0]?.message;
	}
	return null;
};

const formatError = (error) => {
	if (!error) {
		return 'Something went wrong. Please try again';
	}
	if (typeof error === 'string') {
		let parseValues = JSON.parse(error);
		if (Object.keys(parseValues).length) {
			return formatErrorObject(parseValues);
		}
		return error;
	}

	if (error?.errors && typeof error?.errors == 'object') {
		return formatErrorObject(error?.errors);
	}

	if (typeof error == 'object') {
		return formatErrorObject(error);
	}

	return error;
};

// function customAlert(message, onClose) {
// 	const existingAlert = document.querySelector('.overlay-alert');
// 	if (existingAlert) {
// 		document.body.removeChild(existingAlert);
// 	}
// 	const overlay = document.createElement('div');
// 	overlay.className = 'overlay-alert';
// 	const alertBox = document.createElement('div');
// 	alertBox.className = 'alert-box-alert';
// 	const messageParagraph = document.createElement('p');
// 	messageParagraph.textContent = message;
// 	alertBox.appendChild(messageParagraph);
// 	const closeButton = document.createElement('button');
// 	closeButton.textContent = 'Logout';
// 	closeButton.className = 'close-btn-alert';
// 	closeButton.onclick = () => {
// 		document.body.removeChild(overlay);
// 		if (onClose) onClose();
// 	};
// 	alertBox.appendChild(closeButton);
// 	overlay.appendChild(alertBox);
// 	document.body.appendChild(overlay);
// }
